import React, { useEffect } from "react";
import { Button, TableAdv } from "../../../../../components";
import { mapTableRows } from "../../../../../utils";
import { useSelector, useDispatch } from "react-redux";
import { getEmployeeByUiidStart } from "../../../../../redux/slices/employee/employeeSlice";
import { getAllTaxFormDocumentsStart } from "../../../../../redux/slices/document/documentSlice";
const Tab1099 = () => {
  const dispatch = useDispatch();
  const employeeProfileUiid = useSelector(
    (state) => state.employee.employeeProfileUiid
  );
  const { employeeDetails, loadedTabs } = useSelector(
    (state) => state.employee.currentEmployee
  );

  const { 1099: data1099 } = employeeDetails || {};
  const documents = useSelector((state) => state.documents.taxForm) || {};
  const tableData = documents?.Form1099 || [];
  const columns = [
    {
      key: "year",
      label: "1099 Year",
      sortable: false,
    },

    {
      key: "amount",
      label: "1099 Amount",
      sortable: false,
    },

    {
      key: "ein",
      label: "EIN",
      sortable: false,
    },

    {
      key: "address",
      label: "Address",
      render: (row) => (
        <div>
          {row.address.city},{row.address.state},{row.address.country}-
          {row.address.zipCode}
        </div>
      ),
    },

    // {
    //   key: "attachments",
    //   label: "Attachments",
    //   render: (row) => (
    //     <div
    //       className="flex items-center gap-1 flex-row cursor-pointer"
    //       //   onClick={() => handleclick()}
    //     >
    //       <span className="text-linkblue">{row.attachments} Docs </span>
    //     </div>
    //   ),
    // },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2 flex-row">
          <Button
            type="icon"
            icon="edit"
            size="xs"
            variant="text"
            color="black"
          />
          {/* <Button
              type="icon"
              icon="delete"
              size="xs"
              variant="text"
              color="black"
            /> */}
        </div>
      ),
      sortable: false,
    },
  ];
  const mappedRows = mapTableRows(tableData, columns);

  /////// Load data from redux store
  useEffect(() => {
    if (employeeProfileUiid) {
      dispatch(
        getAllTaxFormDocumentsStart({
          tab: "w4FormTab",
          ret: "Form1099",
          coll: "EmpTaxform",
          fil: {
            employeeId: {
              type: "NONE",
              value: employeeProfileUiid,
            },
            taxType: {
              type: "NONE",
              value: 3,
            },
          },
          ref: "Document",
        })
      );
    }
  }, [employeeProfileUiid, loadedTabs, dispatch]);

  return (
    <div className="mt-3">
      <TableAdv tableId={`employee_documents_1099`} rows={mappedRows} columns={columns} hideToolBar />
    </div>
  );
};

export default Tab1099;
